/* EkDoTee quick add: pick a size right on the product card, no page change. */
(function () {
  if (!window.fetch) return;
  var cache = {};
  var root = (window.theme && window.theme.routes && window.theme.routes.root) || '/';
  if (root.slice(-1) !== '/') root += '/';
  var cartAddUrl = ((window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add') + '.js';
  var cartUrl = ((window.theme && window.theme.routes && window.theme.routes.cart) || '/cart') + '.js';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function optName(o) { return String(typeof o === 'string' ? o : (o && o.name) || '').toLowerCase(); }

  /* ---------- Shared feedback ---------- */
  var toastTimer;
  function toast(msg, isError) {
    var t = document.getElementById('CartToast');
    if (!t) return;
    t.querySelector('[data-toast-msg]').textContent = msg;
    t.classList.toggle('is-error', !!isError);
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 4500);
  }
  function cartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n; el.hidden = n === 0;
      el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
    });
  }
  function coin(btn, type) {
    if (!btn || reduceMotion) return;
    if (!document.getElementById('plusOneStyle')) {
      var st = document.createElement('style'); st.id = 'plusOneStyle';
      st.textContent = '.plus-one{position:fixed;z-index:9999;pointer-events:none;display:flex;align-items:center;gap:6px;font:700 15px/1 ui-monospace,SFMono-Regular,Menlo,Consolas,monospace;letter-spacing:.06em;color:#141414;background:#D4FF3A;border:2px solid #141414;padding:6px 9px;box-shadow:3px 3px 0 #141414;animation:plusOne 1.1s steps(8,end) forwards}.plus-one svg{width:16px;height:16px;display:block}@keyframes plusOne{0%{opacity:0;transform:translate(-50%,0) scale(.6)}15%{opacity:1;transform:translate(-50%,-14px) scale(1.1)}75%{opacity:1;transform:translate(-50%,-56px) scale(1)}100%{opacity:0;transform:translate(-50%,-76px) scale(1)}}';
      document.head.appendChild(st);
    }
    var r = btn.getBoundingClientRect();
    var el = document.createElement('div');
    el.className = 'plus-one'; el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<svg viewBox="0 0 8 8" shape-rendering="crispEdges"><path fill="#141414" d="M2 0h4v1H2zM1 1h1v1H1zM6 1h1v1H6zM0 2h1v4H0zM7 2h1v4H7zM1 6h1v1H1zM6 6h1v1H6zM2 7h4v1H2z"/><path fill="#FFD23F" d="M2 1h4v1H2zM1 2h6v4H1zM2 6h4v1H2z"/><path fill="#141414" d="M3 2h2v1H3zM4 3h1v2H4zM3 5h2v1H3z"/></svg><span>+1 ' + (type === 'Badges' ? 'BADGE' : 'TEE') + '</span>';
    el.style.left = (r.left + r.width / 2) + 'px';
    el.style.top = (r.top - 8) + 'px';
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 1200);
  }

  /* ---------- Add to bag ---------- */
  function add(variantId, btn, qa) {
    if (btn) btn.classList.add('is-loading');
    return fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d.description || res.d.message || 'Could not add to bag');
        var item = res.d.items ? res.d.items[0] : res.d;
        var size = item && item.variant_title ? ' (' + item.variant_title + ')' : '';
        toast((item && item.product_title ? item.product_title : 'Tee') + size + ' added to bag');
        coin(btn, item && item.product_type);
        if (qa) done(qa);
        return fetch(cartUrl).then(function (r) { return r.json(); });
      })
      .then(function (cart) { if (cart) cartCount(cart.item_count); })
      .catch(function (err) { toast(err.message, true); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }
  function done(qa) {
    qa.classList.add('is-done');
    var head = qa.querySelector('.qa__title');
    if (head) head.textContent = 'In the bag!';
    setTimeout(function () { close(qa); qa.classList.remove('is-done'); if (head) head.textContent = 'Pick your size'; }, 1300);
  }

  /* ---------- Panel ---------- */
  function load(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('Could not load sizes'); return r.json(); })
      .then(function (p) { cache[handle] = p; return p; });
  }
  function render(qa, p) {
    var body = qa.querySelector('[data-qa-body]');
    var opts = p.options || [];
    var sizeIdx = -1, pickIdx = -1;
    opts.forEach(function (o, i) {
      var n = optName(o);
      if (sizeIdx < 0 && n.indexOf('size') > -1) sizeIdx = i;
    });
    if (sizeIdx < 0) sizeIdx = opts.length - 1;
    opts.forEach(function (o, i) { if (i !== sizeIdx && pickIdx < 0) pickIdx = i; });
    var key = function (i) { return 'option' + (i + 1); };
    var unique = function (i) {
      var seen = [];
      p.variants.forEach(function (v) { var x = v[key(i)]; if (x != null && seen.indexOf(x) < 0) seen.push(x); });
      return seen;
    };
    var html = '';
    var picks = pickIdx > -1 ? unique(pickIdx) : [];
    var firstAvail = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    var selectedColour = qa.dataset.selectedColour;
    if (selectedColour && pickIdx > -1 && /^(color|colour|colors|colours|farbe|couleur|colore|रंग)$/.test(optName(opts[pickIdx]))) {
      firstAvail = p.variants.find(function (v) { return v[key(pickIdx)] === selectedColour && v.available; }) || p.variants.find(function (v) { return v[key(pickIdx)] === selectedColour; }) || firstAvail;
    }
    if (picks.length > 1) {
      var label = typeof opts[pickIdx] === 'string' ? opts[pickIdx] : opts[pickIdx].name;
      html += '<label class="qa__pick"><span>' + esc(label) + '</span><select data-qa-pick>' +
        picks.map(function (v) { return '<option value="' + esc(v) + '"' + (v === firstAvail[key(pickIdx)] ? ' selected' : '') + '>' + esc(v) + '</option>'; }).join('') +
        '</select></label>';
    }
    html += '<div class="qa__sizes" data-qa-sizes></div>';
    body.innerHTML = html;
    var sizesEl = body.querySelector('[data-qa-sizes]');
    var select = body.querySelector('[data-qa-pick]');
    function drawSizes() {
      var chosen = select ? select.value : (pickIdx > -1 ? picks[0] : null);
      sizesEl.innerHTML = unique(sizeIdx).map(function (s) {
        var v = p.variants.filter(function (x) { return x[key(sizeIdx)] === s && (chosen == null || x[key(pickIdx)] === chosen); })[0];
        var ok = v && v.available;
        return '<button type="button" class="qa__size"' + (ok ? ' data-qa-variant="' + v.id + '"' : ' disabled aria-disabled="true"') +
          ' aria-label="Add size ' + esc(s) + (ok ? '' : ', sold out') + '">' + esc(s) + '</button>';
      }).join('');
    }
    if (select) select.addEventListener('change', function () {
      drawSizes();
      if (/^(color|colour|colors|colours|farbe|couleur|colore|रंग)$/.test(optName(opts[pickIdx]))) {
        var card = qa.closest('.card');
        var swatch = card && Array.from(card.querySelectorAll('[data-card-colour]')).find(function (button) { return button.dataset.cardColour === select.value; });
        if (swatch && qa.dataset.selectedColour !== select.value) swatch.click();
      }
    });
    drawSizes();
  }
  function open(qa) {
    document.querySelectorAll('[data-quick-add].is-open').forEach(function (o) { if (o !== qa) close(o); });
    var panel = qa.querySelector('[data-qa-panel]');
    qa.classList.add('is-open');
    qa.closest('.card') && qa.closest('.card').classList.add('is-qa-open');
    panel.hidden = false;
    qa.querySelector('[data-qa-open]').setAttribute('aria-expanded', 'true');
    load(qa.dataset.handle)
      .then(function (p) { render(qa, p); var f = qa.querySelector('.qa__size:not([disabled]), [data-qa-pick]'); if (f) f.focus({ preventScroll: true }); })
      .catch(function (err) { qa.querySelector('[data-qa-body]').innerHTML = '<span class="qa__note">' + esc(err.message) + '</span>'; });
  }
  function close(qa) {
    var panel = qa.querySelector('[data-qa-panel]');
    if (panel) panel.hidden = true;
    qa.classList.remove('is-open');
    qa.closest('.card') && qa.closest('.card').classList.remove('is-qa-open');
    var b = qa.querySelector('[data-qa-open]');
    if (b) b.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-qa-open]');
    if (openBtn) {
      e.preventDefault();
      var qa = openBtn.closest('[data-quick-add]');
      if (qa.dataset.variant) { add(qa.dataset.variant, openBtn, null); return; }
      if (qa.classList.contains('is-open')) close(qa); else open(qa);
      return;
    }
    var closeBtn = e.target.closest('[data-qa-close]');
    if (closeBtn) { e.preventDefault(); var q = closeBtn.closest('[data-quick-add]'); close(q); q.querySelector('[data-qa-open]').focus({ preventScroll: true }); return; }
    var size = e.target.closest('[data-qa-variant]');
    if (size) { e.preventDefault(); add(size.dataset.qaVariant, size, size.closest('[data-quick-add]')); return; }
    if (!e.target.closest('[data-quick-add]')) document.querySelectorAll('[data-quick-add].is-open').forEach(close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var qa = document.querySelector('[data-quick-add].is-open');
    if (qa) { close(qa); qa.querySelector('[data-qa-open]').focus({ preventScroll: true }); }
  });
})();
